module.exports = __webpack_public_path__ + "img/lamp.e634f7e5.svg";